/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_UnlimitedInputs */

const fr_admin_subscription_rights_unlimited = /** @type {(inputs: Admin_Subscription_Rights_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`illimité`)
};

/**

* @param {Admin_Subscription_Rights_UnlimitedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_unlimited = /** @type {((inputs?: Admin_Subscription_Rights_UnlimitedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_UnlimitedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_unlimited(inputs)
});